import draw from "./draw";

class CoefAnimation {
  constructor(x, y, r, vd, ctx, coef) {
    this.anim = { x: x, y: y, radius: r }; // anim falling points
    this.ctx = ctx;
    this.font = { font: 6.6, x: x, y: y };
    this.r = r;
    this.vd = vd;
    this.coef = coef;
    this.draw = draw.bind(this);
  }
}
export default CoefAnimation;
